import { useEffect, useState } from "react";
import { Banner } from "../Banner";

type TranslationAlertProps = {
  isVisible: boolean
  onClose?: () => void
};

export const TranslationAlert = ({ isVisible }: TranslationAlertProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setVisible(true);
    }
    else {
      setTimeout(() => setVisible(false), 300);
    }
  }, [isVisible]);

  if (!visible) return null;

  return (
    <Banner
      title="Traduction automatique détectée"
      description="La traduction automatique de Chrome peut causer des problèmes d'affichage sur notre site.
                  Veuillez la désactiver pour une meilleure expérience. Une fois la traduction automatique désactivée, veuillez rafraîchir la page."
      gradient={{
        from: "#818cf8",
        to: "#9333ea",
      }}
      actionText="Comment désactiver la traduction ?"
      actionUrl="https://support.google.com/chrome/answer/173424"
      showCloseButton={false}
      showOverlay
    />
  );
};
